import { KeycloakStore } from './store';

export const keycloakStore = new KeycloakStore();
